import { useState, useEffect } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Input } from '@/components/ui/input';

const CITY_SPLIT = /\n?(?:Città|City): /;

const parseWorkplace = (val) => {
  const [text = '', city = ''] = (val || '').split(CITY_SPLIT);
  return { text, city };
};

export function WorkplaceInput({ value, onChange, onCityChange, language, setValidationWarning }) {
  const [fields, setFields] = useState(() => parseWorkplace(value));
  const cityLabel = language === 'it' ? 'Città' : 'City';

  useEffect(() => { onCityChange?.(fields.city); }, [fields.city]);

  const update = (key, val) => {
    const updated = { ...fields, [key]: val };
    setFields(updated);
    const city = updated.city.trim() ? `${cityLabel}: ${updated.city.trim()}` : '';
    onChange([updated.text.trim(), city].filter(Boolean).join('\n'));
    if (setValidationWarning) setValidationWarning(null);
  };

  return (
    <div className="space-y-3">
      <Textarea
        value={fields.text}
        onChange={(e) => update('text', e.target.value)}
        placeholder={language === 'it' 
          ? 'Inserisci: Nome azienda, Indirizzo (via, numero), Eventuali altre sedi...' 
          : 'Enter: Company name, Address (street, number), Any other locations...'}
        data-testid="answer-input"
        className="cyber-input w-full min-h-[140px] resize-none rounded-md p-4 text-base"
        autoFocus
      />
      <div>
        <label className="font-mono text-xs text-gray-400 block mb-1">{cityLabel} *</label>
        <Input
          type="text"
          value={fields.city}
          onChange={(e) => update('city', e.target.value)}
          placeholder={language === 'it' ? 'Es: Milano' : 'Ex: Milan'}
          data-testid="workplace-city"
          className="cyber-input w-full h-12 rounded-md px-3 text-sm"
        />
      </div>
      <div className="font-mono text-xs text-neon-cyan/60">
        {language === 'it' 
          ? '💡 Includi: nome azienda, indirizzo completo, e se ci sono più sedi' 
          : '💡 Include: company name, full address, and if there are multiple locations'}
      </div>
    </div>
  );
}

export function TextInput({ value, onChange, onKeyDown, placeholder }) {
  return (
    <Textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      data-testid="answer-input"
      className="cyber-input w-full min-h-[120px] resize-none rounded-md p-4 text-base"
      autoFocus
    />
  );
}

export function ValidationWarning({ message, language }) {
  if (!message) return null;
  
  return (
    <div className="mt-4 p-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg">
      <p className="font-mono text-sm text-yellow-400">
        ⚠️ {message}
      </p>
      <p className="font-mono text-xs text-yellow-400/70 mt-2">
        {language === 'it' 
          ? 'Clicca "Avanti" di nuovo per procedere comunque' 
          : 'Click "Next" again to proceed anyway'}
      </p>
    </div>
  );
}
